import { render } from "./NavListSubheader.vue?vue&type=template&id=aa3388dc&scoped=true"
import script from "./NavListSubheader.vue?vue&type=script&lang=js"
export * from "./NavListSubheader.vue?vue&type=script&lang=js"

import "./NavListSubheader.vue?vue&type=style&index=0&id=aa3388dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa3388dc"]])

export default __exports__